export class WixComms {
  public enabled: boolean = false;
  constructor() {
    window.addEventListener('message', this.handleWixMessage.bind(this));
  }
  public handleWixMessage (data: MessageEvent<any>) {
    if(data.origin.indexOf('purrbinta.com')>-1){
      console.log('Message from Wix', data);
      this.enabled = true;
    }
  }
  public sendMessage(msg: any){
    window?.top?.postMessage(msg, '*');
  }
}
